import { render } from "./ApplicationView.vue?vue&type=template&id=2ae6ec45&scoped=true"
import script from "./ApplicationView.vue?vue&type=script&lang=js"
export * from "./ApplicationView.vue?vue&type=script&lang=js"

import "./ApplicationView.vue?vue&type=style&index=0&id=2ae6ec45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae6ec45"]])

export default __exports__